<template>
    <div>
        <breadcrumb :routerList="[{to:'/yuce/wxhuizong',title:'外销列表'},{title:'外销修改审核'}]"/>

            <div class="h-content">
                <div class="h-row h-mrt0">
                    <div class="h-rowIn">
                        <div class="h-rowBox">
                            <div class="h-rowCon">
                                <div class="h-pieceIn2">
                                    <div class="h-pieceTitle2" style="margin-bottom:0.3rem">
                                        <h1>预测基本信息</h1>
                                    </div>
                                    <div class="h-pieceCon2">
                                        <div class="h-formLine weekplandetail14">
                                            <el-form ref="form"
                                                     :inline="true" class="demo-ruleForm h-formbLine h-dialogForm">

                                                <el-form-item  label="预测编码" class="h-elformWrap-2">
                                                    <el-input placeholder="" v-model="tableData.id"
                                                              :disabled="true"></el-input>
                                                </el-form-item>
                                                <el-form-item  label="区域" class="h-elformWrap-2">
                                                    <el-input placeholder="" v-model="tableData.areaStr"
                                                              :disabled="true"></el-input>
                                                </el-form-item>
                                                <el-form-item  label="国家名称" class="h-elformWrap-2">
                                                    <el-input placeholder="" v-model="tableData.countryStr"
                                                              :disabled="true"></el-input>
                                                </el-form-item>
                                                <el-form-item label="产品编码" class="h-elformWrap-2">
                                                    <el-input placeholder="" v-model="tableData.proCode"
                                                              :disabled="true"></el-input>
                                                </el-form-item>
                                                <el-form-item label="产品型号" class="h-elformWrap-2">
                                                    <el-input placeholder="" v-model="tableData.proModel"
                                                              :disabled="true"></el-input>
                                                </el-form-item>
                                              <!--  <el-form-item label="型号属性" class="h-elformWrap-2">
                                                    <el-input placeholder="" v-model="tableData.protype"
                                                              :disabled="true"></el-input>
                                                </el-form-item>-->
                                                <el-form-item label="数量" class="h-elformWrap-2">
                                                    <el-input v-model="tableData.proNumber" placeholder="产品数量" :disabled="true"
                                                              onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}">
                                                    </el-input>
                                                </el-form-item>
                                                <el-form-item label="常规或改制" class="h-elformWrap-2" v-if="tableData.isSpecific">
                                                    <brselect category="shifou_dingzhi" :v="tableData.isSpecific"
                                                              v-model="tableData.isSpecific" placeholder="请选择" :disabled="true"/>
                                                </el-form-item>
                                                <el-form-item label="改制大类" class="h-elformWrap-2" v-if="tableData.isSpecific==2">
                                                    <el-input  v-model="tableData.specificReq"
                                                               :disabled="true"
                                                               placeholder="描述"></el-input>
                                                </el-form-item>
                                                <el-form-item label="改制要求" class="h-elformWrap-2" v-if="tableData.isSpecific==2">
                                                    <el-input v-model="tableData.specificReform"
                                                              :disabled="true"
                                                              placeholder="改制要求"  >
                                                    </el-input>
                                                </el-form-item>
                                                <el-form-item label="单台价加(元)" class="h-elformWrap-2" v-if="tableData.isSpecific==2">
                                                    <el-input placeholder="请输入..." v-model="tableData.reformPriceRmb" :disabled="true"></el-input>
                                                </el-form-item>


                                                <!--自产有预排-->
                                                <el-form-item label="占用预排单类型" class="h-elformWrap-2" v-if="tableData.protype=='自产'">
                                                    <el-select v-model="tableData.isScheduling" :disabled="true">
                                                        <el-option value="1" label="自己"></el-option>
                                                        <el-option value="2" label="他人"></el-option>
                                                    </el-select>
                                                </el-form-item>
                                                <el-form-item label="预排单号" class="h-elformWrap-2" v-if="isYPdisabled">
                                                    <el-input v-model="tableData.preId" placeholder="预排单号" :disabled="true">
                                                    </el-input>
                                                </el-form-item>
                                                <!--<el-form-item label="预排数量" class="h-elformWrap-2" v-if="isYPdisabled">
                                                    <el-input v-model="tableData.ypNumber" placeholder="产品数量"
                                                              onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}">
                                                    </el-input>
                                                </el-form-item>-->
                                          <!--      <el-form-item label="个人预测数量" class="h-elformWrap-2">
                                                    <el-input v-model="tableData.oneNumber" placeholder="产品数量" :disabled="true">
                                                    </el-input>
                                                </el-form-item>-->
                                                <!--定制可选占用他人预测-->
                                                <el-form-item label="占用预测单类型" class="h-elformWrap-2" v-if="tableData.isSpecific==2">
                                                    <el-select  v-model="tableData.isOther" :disabled="true">
                                                        <el-option value="1" label="自己"></el-option>
                                                        <el-option value="2" label="他人"></el-option>
                                                    </el-select>
                                                </el-form-item>
                                                <el-form-item label="使用已预测库存" class="h-elformWrap-2" v-if="tableData.useMeg">
                                                    <el-input v-model="tableData.useMeg" placeholder="已预测库存" :disabled="true">
                                                    </el-input>
                                                </el-form-item>

                                                <el-form-item label="使用他人已预测库存" class="h-elformWrap-2" v-if="tableData.otherUseId">
                                                    <el-input v-model="tableData.otherUseId" placeholder="他人已预测库存" :disabled="true">
                                                    </el-input>
                                                </el-form-item>
                                           <!--     <el-form-item label="他人预测数量" class="h-elformWrap-2" v-if="tableData.otherNumber">
                                                    <el-input v-model="tableData.otherNumber" placeholder="产品数量" :disabled="true"
                                                              onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}">
                                                    </el-input>
                                                </el-form-item>-->


                                                <el-form-item label="改制类型" class="h-elformWrap-2" v-if="tableData.isSpecific==2">
                                                    <el-select   v-model="tableData.isReformStock" :disabled="true">
                                                        <el-option value="0" label="生产改制"></el-option>
                                                        <el-option value="1" label="库存改制"></el-option>
                                                    </el-select>
                                                </el-form-item>

                                                <!--OEM有发货方式-->
                                                <el-form-item label="发货方式" class="h-elformWrap-2" v-if="tableData.deliveryMethod">
                                                    <el-select  v-model="tableData.deliveryMethod" :disabled="true">
                                                        <el-option value="1" label="直发"></el-option>
                                                        <el-option value="2" label="库发"></el-option>
                                                    </el-select>
                                                </el-form-item>

                                                <el-form-item label="是否实单" class="h-elformWrap-2">
                                                    <el-select   v-model="tableData.isReal" :disabled="true">
                                                        <el-option value="0" label="备货"></el-option>
                                                        <el-option value="1" label="实单"></el-option>
                                                    </el-select>
                                                </el-form-item>
                                                <el-form-item label="预计交货时间" class="h-elformWrap-2"  >
                                                    <el-input v-model="tableData.deliveryDate" :disabled="true"></el-input>
                                                </el-form-item>
                                                <el-form-item label="备注"  class="h-elformWrap-2" >
                                                    <el-input v-model="tableData.remark" placeholder="备注" :disabled="true" ></el-input>
                                                </el-form-item>
                                            </el-form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="h-txtCenter h-mrt60">

                </div>
            </div>

            <div class="h-content">
                <div class="h-row h-mrt0">
                    <div class="h-rowIn">
                        <div class="h-rowBox">
                            <div class="h-row " style="margin-top:30px;padding:0;" v-if="ycTable.length > 0">
                                <div class="h-rowCon" style="padding-bottom:0">
                                    <div class="h-pieceIn2" style="padding-left:0.26rem;">
                                        <div class="h-pieceTitle2"
                                             style="margin-bottom: 0.3rem;display: flex;justify-content: space-between;align-items: center;">
                                            <h1>占用预测库存信息</h1>
                                        </div>
                                    </div>
                                    <el-table
                                            ref="multipleTable"
                                            :data="ycTable"
                                            stripe
                                            border
                                            max-height="500"
                                            style="width: 100%">
                                        <el-table-column
                                                type="index"
                                                label="#">
                                        </el-table-column>
                                        <el-table-column
                                                prop="id"
                                                :show-overflow-tooltip="true"
                                                label="预测编码">
                                        </el-table-column>
                                        <el-table-column
                                                prop="country"
                                                :show-overflow-tooltip="true"
                                                label="国家名称">
                                            <template slot-scope="scope">
                                                <dictname category="YLCountry_agent"  :v="scope.row.country"/>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                prop="proModel"
                                                :show-overflow-tooltip="true"
                                                label="型号">
                                        </el-table-column>
                                        <el-table-column
                                                prop="proCode"
                                                :show-overflow-tooltip="true"
                                                label="产品编码">
                                        </el-table-column>
                                        <el-table-column
                                                prop="protype"
                                                label="型号属性"
                                                :show-overflow-tooltip="true">
                                        </el-table-column>
                                        <el-table-column
                                                prop="proNumber"
                                                :show-overflow-tooltip="true"
                                                label="数量">
                                        </el-table-column>
                                        <el-table-column
                                                prop="useNumber"
                                                :show-overflow-tooltip="true"
                                                label="可用数量">
                                        </el-table-column>
                                        <el-table-column
                                                prop="recordNumber"
                                                :show-overflow-tooltip="true"
                                                label="已占用数量">
                                        </el-table-column>
                                        <el-table-column
                                                prop="useInventory"
                                                :show-overflow-tooltip="true"
                                                label="使用库存数量">
                                        </el-table-column>
                                        <el-table-column
                                                prop="stockStatus"

                                                label="库存状态">
                                            <template slot-scope="scope">
                                                <dictname category="kucun_status"  :v="scope.row.stockStatus"/>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                prop="cuname"

                                                label="创建人">
                                        </el-table-column>
                                    </el-table>
                                </div>
                            </div>
                            <div class="h-row " style="margin-top:30px;padding:0;" v-if="otherTable.length > 0">
                                <div class="h-rowCon" style="padding-bottom:0">
                                    <div class="h-pieceIn2" style="padding-left:0.26rem;">
                                        <div class="h-pieceTitle2"
                                             style="margin-bottom: 0.3rem;display: flex;justify-content: space-between;align-items: center;">
                                            <h1>占用他人预测库存信息</h1>
                                        </div>
                                    </div>
                                    <el-table
                                            ref="multipleTable"
                                            :data="otherTable"
                                            stripe
                                            border
                                            max-height="500"
                                            style="width: 100%">
                                        <el-table-column
                                                type="index"
                                                label="#">
                                        </el-table-column>
                                        <el-table-column
                                                prop="id"
                                                :show-overflow-tooltip="true"
                                                label="预测编码">
                                        </el-table-column>
                                        <el-table-column
                                                prop="country"
                                                :show-overflow-tooltip="true"
                                                label="国家名称">
                                            <template slot-scope="scope">
                                                <dictname category="YLCountry_agent"  :v="scope.row.country"/>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                prop="proModel"
                                                :show-overflow-tooltip="true"
                                                label="型号">
                                        </el-table-column>
                                        <el-table-column
                                                prop="proCode"
                                                :show-overflow-tooltip="true"
                                                label="产品编码">
                                        </el-table-column>
                                        <el-table-column
                                                prop="protype"
                                                label="型号属性"
                                                :show-overflow-tooltip="true">
                                        </el-table-column>
                                        <el-table-column
                                                prop="proNumber"
                                                :show-overflow-tooltip="true"
                                                label="数量">
                                        </el-table-column>
                                        <el-table-column
                                                prop="useNumber"
                                                :show-overflow-tooltip="true"
                                                label="可用数量">
                                        </el-table-column>
                                        <el-table-column
                                                prop="recordNumber"
                                                :show-overflow-tooltip="true"
                                                label="已占用数量">
                                        </el-table-column>
                                        <el-table-column
                                                prop="useInventory"
                                                :show-overflow-tooltip="true"
                                                label="使用库存数量">
                                        </el-table-column>
                                        <el-table-column
                                                prop="stockStatus"
                                                label="库存状态">
                                            <template slot-scope="scope">
                                                <dictname category="kucun_status"  :v="scope.row.stockStatus"/>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                prop="cuname"
                                                label="创建人">
                                        </el-table-column>
                                    </el-table>
                                </div>
                            </div>
                            <div class="h-row " style="margin-top:30px;padding:0;" v-if="ybTable.length > 0">
                                <div class="h-rowCon" style="padding-bottom:0">
                                    <div class="h-pieceIn2" style="padding-left:0.26rem;">
                                        <div class="h-pieceTitle2"
                                             style="margin-bottom: 0.3rem;display: flex;justify-content: space-between;align-items: center;">
                                            <h1>占用预排信息</h1>
                                        </div>
                                    </div>
                                    <el-table
                                            ref="multipleTable"
                                            :data="ybTable"
                                            stripep
                                            border
                                            max-height="500"
                                            style="width: 100%">
                                        <el-table-column
                                                type="index"
                                                label="#">
                                        </el-table-column>
                                        <el-table-column
                                                prop="id"
                                                :show-overflow-tooltip="true"
                                                label="预测编码">
                                        </el-table-column>
                                        <el-table-column
                                                prop="country"
                                                :show-overflow-tooltip="true"
                                                label="国家名称">
                                            <template slot-scope="scope">
                                                <dictname category="YLCountry_agent"  :v="scope.row.country"/>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                prop="proModel"
                                                :show-overflow-tooltip="true"
                                                label="型号">
                                        </el-table-column>
                                        <el-table-column
                                                prop="proCode"
                                                :show-overflow-tooltip="true"
                                                label="产品编码">
                                        </el-table-column>
                                        <el-table-column
                                                prop="protype"
                                                label="型号属性"
                                                :show-overflow-tooltip="true">
                                        </el-table-column>
                                        <el-table-column
                                                prop="proNumber"
                                                :show-overflow-tooltip="true"
                                                label="数量">
                                        </el-table-column>
                                        <el-table-column
                                                prop="useNumber"
                                                :show-overflow-tooltip="true"
                                                label="可用数量">
                                        </el-table-column>
                                        <el-table-column
                                                prop="recordNumber"
                                                :show-overflow-tooltip="true"

                                                label="已占用数量">
                                        </el-table-column>
                                        <el-table-column
                                                prop="cuname"
                                                label="创建人">
                                        </el-table-column>
                                    </el-table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div class="h-table h-mrt30 h-rowBox" v-if="$route.query.taskstatus == 0">
                <div class="h-pieceTitle2 hang">
                    <h1 class="h1">审批意见</h1>
                    <el-form :model="formLabelAlign" label-position="right" :inline="true"
                             class="demo-ruleForm h-formbLine">
                        <el-form-item label="审批意见" class="h-elformWrap-2 " :required="true"
                                      style="margin:30px 0 40px 29px">
                            <el-input v-model="shenhetext" placeholder="请输入"
                                      class="zidaoO"></el-input>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            <div class="apprButton">
				<el-button class="h-btn h-bBtn h-bgwhite" @click="returnTable">返回</el-button>
				<el-button v-if="$route.query.taskstatus == 0" class="h-btn h-bBtn h-bgred" @click="auditFail">驳回</el-button>
				<el-button v-if="$route.query.taskstatus == 0" class="h-btn h-bBtn h-bggreen" @click="auditPass">通过</el-button>
				<el-button class="h-btn h-bBtn h-bgblueQ2" @click="findDetail">查看审批详情</el-button>
            </div>

        <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>
    </div>
</template>
<script>

    import ss from '../../../api/SystemService';

    export default {
        data() {
            return {
                ycTable:[],
                otherTable:[],
                ybTable:[],
                useData:[],
                tableDataOld: [],
                isYPdisabled:false,
                tableData:{
                    id:'',
                    otherNumber:0,
                    ypNumber:0,
                    oneNumber:0,
                    otherUseIds:[],
                    useOtherData:[],
                    useMeg:'',
                    otherUseId:'',
                    isOther:null,
                    isReal:null,
                    isScheduling:null,
                    ypIds:[],
                    preId:'',
                    deliveryMethod:'',
                    isReformStock:null,
                    // isShipDate:'',
                    // shippingDate:'',
                    proNumber:'',
                    oldNumber:'',
                    proModel:'',
                    proCode:'',
                    country:'',
                    countryStr:'',
                    area:'',
                    areaStr:'',
                    specificReform:'',
                    reformPriceRmb:'',
                    specific:[],
                    isSpecific:'',
                    protype:'',
                    remark:'',
                    deliveryDate:'',
                    codeOpt:[],
                    modelOpt:[],
                    uids:[],
                    useData:[],
                    cucode:'',
                },
                formLabelAlign:{},
                shenhetext:'',
                instid: '',
                u: '',
                showhistory: false,
                table: {
                    data: [],
                    optflag: '',
                    yijianMsg: '',
                    aaa: '',
                    taskId: '',
                    instId: ''
                },
                q: {
                    id: '',
                },
            }
        },
        mounted() {

        },
        created() {
            this.table.taskId = this.$route.query.taskid;
            this.table.instId = this.$route.query.instid;
            this.instid = this.$route.query.instid;

            if (this.$store.getters.hasRole('swyl_waixiaogly')) {
                this.u = 1;
            }
            if (this.$store.getters.hasRole('swyl_wxcggly')) {
                this.u = 1;
            }
            this.query();
        },
        methods: {
            /**
             *判断修改之前的值与现在值是否相同 不同就加样式
             * */
            tableCellClassName({row, column, rowIndex, columnIndex}) {
                console.log(row[column.property])
                console.log(this.tableData[column.property])
                if(row[column.property] != this.tableData[column.property]){
                    return 'warning-row';
                }
            },
            addUseId(v) {
                if (!v.useData || v.useData == '') {
                    v.zid = '';
                }
                v.useId = '';
                if (v.useData && v.useData.length != 0 && v.uids && v.uids.length != 0) {
                    for (var i = 0; i < v.useData.length; i++) {
                        for (var j = 0; j < v.uids.length; j++) {
                            if (v.useData[i] == v.uids[j].name) {
                                if (v.useId && v.useId != '') {
                                    v.useId = v.useId + v.uids[j].code + ","
                                } else {
                                    v.useId = v.uids[j].code + ","
                                }
                            }
                        }
                    }
                }
                if (v.zid && v.zid != '') {
                    v.useId = v.zid + v.useId;
                }
            },
            //查看审批流详情
            findDetail() {
                this.showhistory = true;
            },
            query() {
                this.q.id = this.$route.query.ywid;
                ss.waixiao.selectById(this.q).then(rd => {
                    for (var i = 0; i < rd.length; i++) {
                        rd[i]['useData'] = [];
                        rd[i]['uids'] = [];
                        rd[i]['zid'] = '';
                    }

                    this.tableData = rd[0];

                    if(this.tableData.deliveryMethod || this.tableData.deliveryMethod==0){
                        this.tableData.deliveryMethod = this.tableData.deliveryMethod.toString()
                    }
                    if(this.tableData.isScheduling ){
                        this.tableData.isScheduling = this.tableData.isScheduling.toString()
                    }
                    if(this.tableData.isOther ){
                        this.tableData.isOther = this.tableData.isOther.toString()
                    }
                    if(this.tableData.isReal || this.tableData.isReal==0){
                        this.tableData.isReal = this.tableData.isReal.toString()
                    }
                    if(this.tableData.isReformStock || this.tableData.isReformStock==0){
                        this.tableData.isReformStock = this.tableData.isReformStock.toString()
                    }
                    var cou = this.$store.getters.dictlist("YLCountry_agent");
                    for (var j = 0; j < cou.length; j++) {
                        if (cou[j].code == this.tableData.country) {
                            this.tableData.countryStr = cou[j].name
                        }
                    }
                    var quyu = this.$store.getters.dictlist("dj_foreign_area");
                    for (var j = 0; j < quyu.length; j++) {
                        if (quyu[j].code == this.tableData.area) {
                            this.tableData.areaStr = quyu[j].name
                        }
                    }
                    this.isYp();
                    this.selectStock();
                    this.selectStockOther();
                    this.getYPlist();
                })



                ss.waixiao.selectAdjById(this.q).then(rd => {
                    this.tableDataOld = rd;
                })

            },
            isYp(){
                if(this.tableData.isScheduling ){
                    this.isYPdisabled = true;
                }else {
                    this.tableData.ypIds = [];
                    this.isYPdisabled = false;
                }

                if(this.tableData.isOther && this.tableData.isOther == '1'){
                    this.tableData.useOtherData = [];
                    this.otherTable = [];
                }else if(this.tableData.isOther && this.tableData.isOther == '2'){
                    this.tableData.useData = [];
                    this.ycTable = [];
                }else {
                    this.tableData.useData = [];
                    this.ycTable = [];
                    this.tableData.useOtherData = [];
                    this.otherTable = [];
                }

            },

            selectStock() {
                this.ycList = [];
                this.ycTable = [];
                var obj= {
                    id: this.tableData.id,
                    proCode: this.tableData.proCode,
                    cucode:this.tableData.cucode
                }
                ss.waixiao.selectReviseStockUpdate(obj).then(rd => {
                    if (rd && rd.length > 0) {
                        this.ycList = rd;
                    }
                    if (this.tableData.useId) {
                        this.useData = _.split(this.tableData.useId || [], ",");
                    }
                    for (var i = 0; i < this.useData.length; i++) {
                        for(var t=0;t<this.ycList.length;t++){
                            if(this.ycList[t].id == this.useData[i]){
                                this.ycTable.push(this.ycList[t]);
                            }
                        }
                    }
                })
            },
            selectStockOther() {
                this.getOtherData=[];
                this.otherTable = [];
                var obj= {
                    id: this.tableData.id,
                    proCode: this.tableData.proCode,
                    cucode:this.tableData.cucode
                }
                ss.waixiao.selectStockOtherUpdate(obj).then(rd => {
                    if (rd && rd.length > 0) {
                        this.getOtherData = rd;
                    }
                    if (this.tableData.otherUseId) {
                        this.tableData.useOtherData =  _.split(this.tableData.otherUseId || [], ",");
                    }

                    for (var i = 0; i <  this.tableData.useOtherData.length; i++) {
                        for(var t=0;t<this.getOtherData.length;t++){
                            if(this.getOtherData[t].id == this.tableData.useOtherData[i]){
                                this.otherTable.push(this.getOtherData[t]);
                            }
                        }
                    }

                })
            },
            getYPlist(){
                this.getypData = [];
                this.ypData=[];
                this.ybTable=[];
                var obj= {
                    id: this.tableData.id,
                    proCode: this.tableData.proCode,
                    cucode:this.tableData.cucode
                }

                ss.waixiao.selectYpUpdate(obj).then(rd => {
                    if (rd && rd.length > 0) {
                        this.getypData = rd;
                    }
                    if (this.tableData.preId ) {
                        this.ypData =  _.split(this.tableData.preId || [], ",");
                    }
                    for(var i=0;i<this.ypData.length;i++){
                        for(var t=0;t<this.getypData.length;t++){
                            if(this.getypData[t].id==this.ypData[i]){
                                this.ybTable.push(this.getypData[t]);
                            }
                        }
                    }
                })
            },





            auditPass() {
                this.$msg.confirm("是否确认通过此条预测修改申请？", () => {
                    var f = true;
                    if (f) {
                        this.table.aaa = 2
                        this.table.optflag = '审核通过';
                        this.table.yijianMsg = this.shenhetext;
                        this.table.data.push(this.tableData);
                        ss.waixiao.updateRevise(this.table).then(rd => {
                            if (rd.f == true) {
                                this.$msg.msgs(rd.msg);
                                //刷新右上角的代办个数
                                this.$store.dispatch("searchTasktotal")
                                //跳转回系统的代办列表
                                this.$router.push({path:'/personal/dealCenter'})
                            } else {
                                this.$msg.msge(rd.msg);
                            }
                        })
                    }
                })
            },
            auditFail() {
                this.$msg.confirm("是否确认驳回此条预测修改申请？", () => {
                    var reg = /^\s$/;
                    if (reg.test(this.shenhetext)) {
                        this.$msg.msge("审核意见不能为空!");
                        return;
                    }
                    if (this.shenhetext == "") {
                        this.$msg.msge("审核意见不能为空!");
                        return;
                    }
                    this.table.aaa = 1
                    this.table.optflag = '审核被驳回';
                    this.table.yijianMsg = this.shenhetext;
                    this.table.data.push(this.tableData);

                    ss.waixiao.updateRevise(this.table).then(rd => {
                        if (rd.f == true) {
                            this.$msg.msgs(rd.msg);
                            //刷新右上角的代办个数
                            this.$store.dispatch("searchTasktotal")
                            //跳转回系统的代办列表
                            this.$router.push({path:'/personal/dealCenter'})
                        } else {
                            this.$msg.msge(rd.msg);
                        }
                    })
                })
            },
            returnTable() {
                this.$router.push({path:'/personal/dealCenter'})
            }
        }
    }
</script>
<style scoped>
    /*--------------- 审批样式 ----------------*/
    .h1{
        margin: 20px 0 0 31px;
    }
    .bbbb{
        background-color: white;
    }
    .apprButton {
        /* margin-left: 4rem;
        margin-top: 30px;
        padding-bottom: 20px; */
		display: flex;
		justify-content: center;
		align-items: center;
		margin-top: 0.4rem;
    }
    .cancel {
    }
    .pass {
        background-color: #006aca;
        color: white;
    }
    .refuse {
        background-color: #24b5b8;
        color: white;
    }
    .icon .h-tableInput .el-input__inner {
        padding: 0.05rem 0.1rem;
    }
    .icon .h-tableInput .el-input__icon{
        line-height: 0.25rem;
    }

    .icon .el-date-editor.el-input,
    .el-date-editor.el-input__inner {
        width: 90%;
    }

    .yhbrselect .el-input__inner {
        height: 0.6rem;
        border: 0;
        color: #2785e7;
        font-size: 0.18rem;
        background: 0;
    }

    .yhbrselect .el-input__inner:focus {
        border: 1px solid #2785e7;
        box-shadow: 0 0 0.16rem rgba(39, 133, 231, 0.35) inset;
    }

    .h-formBorder.ljjclassforms .el-input__inner {
        border: 0;
        border-bottom: 1px solid #d1d1d1;
    }

    .ljjclasstans .el-dialog__footer {
        text-align: center;
    }
    .weekplandetail14 .h-formbLine .el-form-item__label {
        width: 35%;
        text-align: right;
    }

    .weekplandetail14 .h-formbLine .el-form-item__content {
        width: 65%;
    }

    .weekplandetail14 .h-formbLine .h-elformWrap-2 {
        width: 33.333%;
    }
    .ljjtablepaddings12 .h-tableInput .el-input__inner{
        padding: 0.05rem 0.1rem;
    }

    /*--------------- 审批样式 ------------------*/
</style>
<style>
    .el-table .warning-row {
        background:#fef0f0;
    }

    .el-table .success-row {
        background: #f0f9eb;
    }

</style>